'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    GET_SCREEN_DATA_BUSQUEDA_CLIENTE,
    ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE,
    CHANGE_VALUE_SEARCH_BUSQUEDA_CLIENTE,
    RESULT_SEARCH_CLIENT_DDBB_BUSQUEDA_CLIENTE,
    RESET_BUSQUEDA_CLIENTE,
    RESET_ALL_BUSQUEDA_CLIENTE,
    LOADING_BUSQUEDA_CLIENTE,
    RELOAD_BUSQUEDA_CLIENTE,
    RESET_STATE_BUSQUEDA_CLIENTE,
    NOT_FOUND_CLIENTE_BUSQUEDA_CLIENTE,
    ROUTE_TO_VISTA_GESTION_CLIENTE_BUSQUEDA_CLIENTE,
    SET_CLIENTES_ENCONTRADOS,
    SET_CLIENTE_NO_ENCONTRADO
} from '../../Screens/ClientSearch/actions/Actions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        loading: false,
        ddbbNotFound: false,
        routingState: undefined,
        request: undefined,
        valueSearch: "",
        clientes: [],
        buscoPadron: false,
        redirectToVistaCliente: false,
        redirectToVistaGestionCliente: false,
        noExisteClienteWs: false,
        mostrarListaClietes: false,
        clientesEncontrados: [],
        programaSelccionado: null,
        clienteNoEncontrado: false,
    },
    isFetching: false,
    error: false
};


function busquedaCliente(state = initialState, action) {
    LogHelper.In(busquedaCliente.name, state, action);

    let result;

    switch (action.type) {

        case GET_SCREEN_DATA_BUSQUEDA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false,
                    noExisteClienteWs: false
                }
            };
            break;

        case LOADING_BUSQUEDA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: true,
                    noExisteClienteWs: false
                }
            };
            break;

        case RESET_ALL_BUSQUEDA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false,
                    ddbbNotFound: false,
                    routingState: undefined,
                    request: undefined,
                    valueSearch: "",
                    clientes: [],
                    buscoPadron: false,
                    noExisteClienteWs: false
                }
            };
            break;

        case CHANGE_VALUE_SEARCH_BUSQUEDA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    valueSearch: action.newSerchValue,
                    noExisteClienteWs: false
                }
            };
            break;

        case ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false,
                    redirectToVistaCliente: true,
                    redirectToVistaGestionCliente: false,
                    noExisteClienteWs: false
                }
            };
            break;
        case ROUTE_TO_VISTA_GESTION_CLIENTE_BUSQUEDA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false,
                    redirectToVistaGestionCliente: true,
                    redirectToVistaCliente: false
                }
            };
            break;

        case RESET_BUSQUEDA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    clientes: [],
                    buscoPadron: false,
                    ddbbNotFound: false,
                    noExisteClienteWs: false,
                    clienteNoEncontrado:false,
                    mostrarListaClietes: false,
                    clientesEncontrados: [],
                }
            };
            break;

        case RESULT_SEARCH_CLIENT_DDBB_BUSQUEDA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    clientes: action.resultSearch,
                    ddbbNotFound: action.ddbbNotFound,
                    buscoPadron: true,
                    noExisteClienteWs: false
                }
            };
            break;

        case RELOAD_BUSQUEDA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: true
                }
            };
            break;

        case RESET_STATE_BUSQUEDA_CLIENTE:

            result = initialState
            break;

        case NOT_FOUND_CLIENTE_BUSQUEDA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false,
                    noExisteClienteWs: true,
                    errorBusqueda: (typeof (action.errorBusqueda) === "string" && action.errorBusqueda.includes("One or more errors occurred.")) ? "No se pudo acceder a los datos del Cliente indicado en el repositorio central de la Entidad" : action.errorBusqueda
                }
            };
            break;

        case SET_CLIENTES_ENCONTRADOS:
            result = {
                ...state,
                data: {
                    ...state.data,
                    mostrarListaClietes: true,
                    clientesEncontrados: action.clientesEncontrados,
                    loading: false,
                    programaSelccionado: action.programaSelccionado,
                    clienteNoEncontrado: false,
                }
            };

            break;

        case SET_CLIENTE_NO_ENCONTRADO:
            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false,
                    mostrarListaClietes: false,
                    clienteNoEncontrado: true,
                }
            };
            break;

        default:
            result = {
                ...state
            };
            break;
    }

    LogHelper.Out(busquedaCliente.name, result);
    return result;
}

export default busquedaCliente;